import React, { useState } from 'react';
import { Container, Row, Col, Card, FormGroup, Label, Input, Button, CardBody } from 'reactstrap';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { usePendingWork } from '../../../hooks/workOrder/usePendingWork';
import Select from 'react-select';
import './styleDataTable.css';
import { InputText } from 'primereact/inputtext';
import { Collapse } from "reactstrap";

export const IndexPendingWork = () => {
    const {
        // #region Filters
        branches, mDateRange1, mDateRange2, mSelectBranch,
        // #endregion 

        handleInputChange, handleSelectValues, loading,
        getPedingWork, reportPendingExams, handleClean,
        sections, mSelectSections,

        //Indicators
        totalExam, totalExamsReleased, totalPendingExams, pendingExamsPercentage,

        // search Exams
        handleSearchPedingWork, handleCleanWork


    } = usePendingWork();

    const [expandedRows, setExpandedRows] = useState(null);
    const [globalFilter, setGlobalFilter] = useState('');
    const [openSections, setOpenSections] = useState(false);

    const rowExpansionTemplate = (data) => {
        const columnsPerRow = 5;

        const rows = [];
        for (let i = 0; i < data.pending_nims.length; i += columnsPerRow) {
            rows.push(data.pending_nims.slice(i, i + columnsPerRow));
        }

        return (
            <div className="p-3">
                <h6 style={{ fontSize: '12px', fontWeight: 'bold' }} className='text-secondary'>NIMs Pendientes</h6>
                <table className="table table-bordered" style={{ fontSize: "12px" }}>
                    <tbody>
                        {rows.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                {row.map((nim, index) => (
                                    <td key={index} className="text-center" style={{ fontSize: '12px' }}>
                                        <a
                                            href={`/captura-resultados/${nim}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            onClick={() => {
                                                const sectionsOriginales =
                                                    JSON.parse(
                                                        localStorage.getItem("sections") || "[]"
                                                    );

                                                const filtrosRestaurados =
                                                    sectionsOriginales.map(id => ({
                                                        id_section: id
                                                    }));

                                                localStorage.setItem(
                                                    "filter_sections",
                                                    JSON.stringify(filtrosRestaurados)
                                                );
                                            }}
                                        >
                                            {nim}
                                        </a>
                                    </td>
                                ))}
                                {Array(columnsPerRow - row.length).fill("").map((_, index) => (
                                    <td key={`empty-${index}`} />
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );

    };
    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };



    return (
        <div className='container-global-zoom'>

            <Card style={{
                marginBottom: '15px',
                background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
                border: 'none',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
            }}>
                <CardBody style={{ padding: '18px 25px' }}>
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <div style={{
                                width: '50px',
                                height: '50px',
                                borderRadius: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginRight: '15px'
                            }}>
                                <img alt="flask" className="img-fluid text-info mr-2" src={require("../../../assets/images/pendingWork/pendingWork.png")} style={{ width: "45px", height: "45px" }} />
                            </div>
                            <div>
                                <h4 className="mb-1" style={{ color: '#fff', fontWeight: 700, fontSize: '20px', textAlign: "justify" }}>
                                    Trabajo Pendiente
                                </h4>
                                <small style={{ color: 'rgba(255,255,255,0.85)', fontSize: '13px' }}>
                                    <i className="fa fa-info-circle mr-1"></i>
                                    Consulta de trabajos pendientes por área y periodo.
                                </small>
                            </div>
                        </div>

                    </div>
                </CardBody>
            </Card>

            <Card className='shadow-sm border height-equal pricingtable mb-0 pb-0'>
                <Col sm="12" className="">


                    <Row className="align-items-end g-3 justify-content-center">

                        <Col
                            xs="12"
                            md="2"
                            className="text-center text-md-start"
                        >
                            <h6 className="f-w-700 text-primary mb-3">
                                Filtros de busqueda
                            </h6>
                        </Col>

                        {/* FECHA INICIO */}
                        <Col xs="12" sm="6" md="2">
                            <Label className="f-w-600 f-12 text-primary">
                                Fecha inicio
                            </Label>
                            <Input
                                type="date"
                                value={mDateRange1}
                                name="mDateRange1"
                                onChange={handleInputChange}
                                className="form-control form-control-sm b-r-9"
                            />
                        </Col>

                        {/* FECHA CIERRE */}
                        <Col xs="12" sm="6" md="2">
                            <Label className="f-w-600 f-12 text-primary">
                                Fecha cierre
                            </Label>
                            <Input
                                type="date"
                                value={mDateRange2}
                                name="mDateRange2"
                                onChange={handleInputChange}
                                className="form-control form-control-sm b-r-9"
                            />
                        </Col>

                        {/* SUCURSAL */}
                        <Col xs="12" sm="12" md="2">
                            <Label className="f-w-600 f-12 text-primary">
                                Sucursal
                            </Label>
                            <Select
                                name="mSelectBranch"
                                isClearable
                                placeholder="Selecciona una sucursal"
                                options={branches}
                                onChange={(e) => handleSelectValues(e, 'mSelectBranch')}
                                value={mSelectBranch}
                                classNamePrefix="react-select"
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                }}
                            />
                        </Col>

                        {/* BOTONES */}
                        <Col
                            sm="3"
                            className="d-flex align-items-end justify-content-center"
                            style={{ gap: '12px' }}
                        >

                            <Button
                                onClick={(e) => getPedingWork(e, true)}
                                color="primary"
                                outline
                                disabled={loading}
                                className="px-3"
                                style={{ borderRadius: '10px', fontWeight: 600 }}
                            >
                                {loading ? (
                                    <>
                                        <i className="pi pi-spin pi-spinner me-2"></i>
                                        Buscando...
                                    </>
                                ) : (
                                    'Buscar'
                                )}
                            </Button>

                            <Button
                                onClick={handleClean}
                                outline
                                color="danger"
                                disabled={loading}
                                className="px-3"
                                style={{ borderRadius: '10px', fontWeight: 600 }}
                            >
                                Limpiar
                            </Button>
                        </Col>

                    </Row>


                </Col>
                <br />



            </Card>
            <br />

            <Card className='shadow-sm border height-equal pricingtable mb-0 pb-0'>

                {
                    // * GLOBAL INDICATORS
                }

                <Col sm="12" className="p-l-0 p-r-0  pb-3 container-global-zoom">
                    <Row >
                        <Col xs="12" sm="6" lg="3" className="mb-3">
                            <Card style={{
                                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                border: '3px solid #0f7986',
                                color: 'white',
                                borderRadius: '20px',
                                overflow: 'hidden'
                            }}>

                                <div className="indicator-card-content">


                                    <div className="indicator-left">
                                        <img
                                            src={require("../../../assets/images/pendingWork/test-results.svg")}
                                            className="indicator-icon"
                                            alt=""
                                        />
                                    </div>

                                    <div className="indicator-center">
                                        <div className="indicator-title">
                                            Total de Exámenes
                                        </div>
                                    </div>


                                    <h2 className="indicator-number">
                                        {loading
                                            ? <i className="fa fa-spin fa-spinner font-primary f-24" />
                                            : totalExam()}
                                    </h2>

                                </div>
                            </Card>
                        </Col>



                        <Col xs="12" sm="6" lg="3" className="mb-3">
                            <Card style={{
                                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                border: '3px solid #4bbd00',
                                color: 'white',
                                borderRadius: '20px',
                                overflow: 'hidden'
                            }}>

                                <div className="indicator-card-content">
                                    <div className="indicator-left">
                                        <img
                                            src={require("../../../assets/images/pendingWork/total-exam.svg")}
                                            className="indicator-icon"
                                            alt=""
                                        />
                                    </div>


                                    <div className="indicator-center">
                                        <div className="indicator-title">
                                            Exámenes Liberados
                                        </div>
                                    </div>


                                    <h2 className="indicator-number">
                                        {
                                            loading && <i className="fa fa-spin fa-spinner font-primary f-24"></i>
                                        }
                                        {
                                            !loading && totalExamsReleased()
                                        }
                                    </h2>
                                </div>
                            </Card>
                        </Col>

                        <Col xs="12" sm="6" lg="3" className="mb-3">
                            <Card style={{
                                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                border: '3px solid #63addd',
                                color: 'white',
                                borderRadius: '20px',
                                overflow: 'hidden'
                            }}>

                                <div className="indicator-card-content">

                                    <div className="indicator-left">
                                        <img
                                            src={require("../../../assets/images/pendingWork/exam-time.svg")}
                                            className="indicator-icon"
                                            alt=""
                                        />
                                    </div>

                                    <div className="indicator-center">
                                        <div className="indicator-title">
                                            Exámenes Pendientes
                                        </div>
                                    </div>

                                    <h2 className="indicator-number">
                                        {
                                            loading && <i className="fa fa-spin fa-spinner font-primary f-24"></i>
                                        }
                                        {
                                            !loading && totalPendingExams()
                                        }
                                    </h2>
                                </div>

                            </Card>
                        </Col>

                        <Col xs="12" sm="6" lg="3" className="mb-3">
                            <Card style={{
                                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                border: '3px solid #ffa733',
                                color: 'white',
                                borderRadius: '20px',
                                overflow: 'hidden'
                            }}>

                                <div className="indicator-card-content">

                                    <div className="indicator-left">
                                        <img
                                            src={require("../../../assets/images/price/reportCxcPercentage.svg")}
                                            className="indicator-icon"
                                            alt=""
                                        />
                                    </div>

                                    <div className="indicator-center">
                                        <div className="indicator-title">
                                            Cumplimiento
                                        </div>
                                    </div>

                                    <h2 className="indicator-number">
                                        {
                                            loading && <i className="fa fa-spin fa-spinner font-primary f-24"></i>
                                        }
                                        {!loading && (
                                            <span >
                                                {pendingExamsPercentage()}%
                                            </span>
                                        )}
                                    </h2>
                                    <div>
                                    </div>
                                </div>

                            </Card>
                        </Col>
                    </Row>
                    {
                        // * Seccions
                    }

                </Col>

                <Row>
                    <Col xs="12" lg="4">
                        <Card>

                            <div className="d-none d-md-block">
                                <div className="ribbon ribbon-clip ribbon-primary">
                                    Secciones
                                </div>
                            </div>

                            <div
                                className="mobile-section-header d-flex d-md-none justify-content-between align-items-center"
                                onClick={() => setOpenSections(!openSections)}
                            >
                                <div className="d-flex align-items-center">
                                    <i className="fa fa-th-large mr-2"></i>
                                    <span>Secciones</span>
                                </div>

                                <div className="d-flex align-items-center">

                                    <button
                                        className="btn-clear-sections"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleCleanWork();
                                        }}
                                    >
                                        <img
                                            src={require("../../../assets/images/borrar.png")}
                                            alt=""
                                        />
                                    </button>

                                    <i
                                        className={`fa ml-3 ${openSections ? "fa-chevron-up" : "fa-chevron-down"
                                            }`}
                                    />

                                </div>

                            </div>



                            <div className="d-none d-md-block">
                                <CardBody className="mt-3">

                                    <div className="d-flex flex-column align-items-center">

                                        {sections.length > 0 ? (

                                            sections.reduce((rows, section, index) => {

                                                if (index % 2 === 0) rows.push([section]);
                                                else rows[rows.length - 1].push(section);

                                                return rows;

                                            }, []).map((row, rowIndex) => (

                                                <div key={rowIndex} className="d-flex w-100 justify-content-center mb-2">

                                                    {row.map((section) => (

                                                        <Button
                                                            key={section.value}
                                                            onClick={() => handleSelectValues(section, "mSelectSections")}
                                                            color={mSelectSections?.value === section.value ? "primary" : "secondary"}
                                                            size="sm"
                                                            className="w-50 mx-1"
                                                            outline={mSelectSections?.value !== section.value}
                                                        >
                                                            {section.label}
                                                        </Button>

                                                    ))}

                                                </div>

                                            ))

                                        ) : (

                                            <p>No hay secciones disponibles</p>

                                        )}

                                    </div>

                                </CardBody>
                            </div>

                            {/* Móvil colapsable */}
                            <Collapse isOpen={openSections} className="d-md-none">

                                <CardBody>

                                    <div className="d-flex flex-column align-items-center">

                                        {sections.length > 0 ? (

                                            sections.reduce((rows, section, index) => {

                                                if (index % 2 === 0) rows.push([section]);
                                                else rows[rows.length - 1].push(section);

                                                return rows;

                                            }, []).map((row, rowIndex) => (

                                                <div key={rowIndex} className="d-flex w-100 justify-content-center mb-2">

                                                    {row.map((section) => (

                                                        <Button
                                                            key={section.value}
                                                            onClick={() => {
                                                                handleSelectValues(section, "mSelectSections");
                                                                setOpenSections(false); // opcional: cerrar al seleccionar
                                                            }}
                                                            color={mSelectSections?.value === section.value ? "primary" : "secondary"}
                                                            size="sm"
                                                            className="w-50 mx-1"
                                                            outline={mSelectSections?.value !== section.value}
                                                        >
                                                            {section.label}
                                                        </Button>

                                                    ))}

                                                </div>

                                            ))

                                        ) : (

                                            <p>No hay secciones disponibles</p>

                                        )}

                                    </div>

                                </CardBody>

                            </Collapse>

                        </Card>
                    </Col>

                    <Col sm="8">
                        {
                            // * DATATABLE 
                        }
                        <div style={{
                            marginTop: '20px',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                            borderRadius: '12px',
                            overflow: 'hidden',
                            backgroundColor: '#fff'
                        }}>
                            <Row className='mb-2 justify-content-end'>
                                <Col sm="4">
                                    {/* <Input type='search' placeholder='Busqueda...' className='form-control' onChange={handleSearchPedingWork} /> */}
                                    <InputText
                                        type="search"
                                        className="pl-6"
                                        onChange={handleSearchPedingWork}

                                        style={{ width: "100%" }}
                                        placeholder='Búsqueda...'
                                    />
                                </Col>
                            </Row>
                            <DataTable
                                value={reportPendingExams}
                                loading={loading}
                                responsiveLayout="scroll"
                                expandedRows={expandedRows}
                                onRowToggle={(e) => setExpandedRows(e.data)}
                                rowExpansionTemplate={rowExpansionTemplate}
                                paginator
                                rows={10}
                                rowsPerPageOptions={[10, 16, 24, 50]}
                                className='data-table p-datatable-striped p-datatable-sm'

                                emptyMessage={
                                    <div className="text-center">
                                        <img
                                            src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                            style={{ width: "35%" }}
                                            alt="Sin resultados"
                                        />
                                        <br />
                                        <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>
                                            No hay coincidencias con la búsqueda.
                                        </p>
                                    </div>
                                }
                            >
                                <Column expander frozen headerStyle={headerStyle} style={centerStyle} />
                                <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />

                                <Column field="name" header="Nombre" sortable headerStyle={headerStyle} style={centerStyle} />
                                <Column field="num_exams" header="Total de Exámenes" sortable headerStyle={headerStyle} style={centerStyle} />
                                <Column field="num_exams_released" header="Exámenes Liberados" sortable headerStyle={headerStyle} style={centerStyle} />
                                <Column field="pendingExams" header="Exámenes Pendientes" sortable headerStyle={headerStyle} style={centerStyle} />


                            </DataTable>
                        </div>
                    </Col>

                    <br />
                </Row>
                <br /><br /><br /> <br /> <br />

            </Card>


        </div>
    );
};









